import { PieChart } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgChartPie = mkIcon(PieChart);
